import { useEffect, useState } from 'react';
import { GetUserDetailForUpdate } from '../../../../../reduxToolkit/Contractor/ContractorApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { VISITOR_MODEL } from '../../../Visitor/Model/Model';
import HeadTittle from '../../../../../components/HeadTittle';
import IdentityVerification from '../../../Visitor/Visitor/SubComponents/IdentityVerification';
import { GetAllUserFiles } from '../../../../../reduxToolkit/UserFile/UserFileApi';
import {
    formatName,
    getIdentityValidationTypeById,
    IDENTITY_DOCUMENTS_MODEL,
    IDENTITY_VALIDATION_CARD_MODEL,
} from '../../../Visitor/Visitor/Model/Model';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { DownloadIcon } from '../../../../../components/buttons/IconButtons';
import {toast} from "react-toastify";
import {errorMsg, getFullName} from "../../../../../Apis/functions";
import {DownloadDataZip, ZipDownloadByUserId} from "../../../../../reduxToolkit/fileUpload/FileUploadApi";
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
// Component responsible for displaying and managing user identity documents
const IdentityDocumentsGrid = () => {
    const { id: userId } = useParams();
    const { state } = useLocation();
    const backRoute = state?.backUrl;
    const currentTab = state?.currentTab;

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    // Stores base user information
    const [item, setItem] = useState({ ...VISITOR_MODEL });
    // Stores identity documents
    const [identityDocuments, setIdentityDocuments] = useState({ ...IDENTITY_DOCUMENTS_MODEL });
    // Stores the type of identity validation
    const [identityValidationType, setIdentityValidationType] = useState(null);
    // Stores the current identity validation status
    const [identityValidationStatus, setIdentityValidationStatus] = useState(null);
    // Load user data and identity documents when the component mounts
    useEffect(() => {
        getData();
    }, []);
    // Retrieves user details and associated identity documents
    const getData = () => {
        dispatch(GetUserDetailForUpdate(userId)).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                let aux = data;
                if (aux?.id) {
                    setItem(VISITOR_MODEL.set(aux));
                    setIdentityValidationType(getIdentityValidationTypeById(aux?.identityValidationType));
                    setIdentityValidationStatus(
                        IDENTITY_VALIDATION_CARD_MODEL.getIdentityValidationStatus(aux?.identityValidation?.id),
                    );
                    // Fetch and map all user identity files
                    dispatch(GetAllUserFiles(userId)).then(
                        ({
                            payload: {
                                data: { data },
                            },
                        }) => {
                            setIdentityDocuments(IDENTITY_DOCUMENTS_MODEL.set(data, aux));
                        },
                    );
                }
            },
        );
    };
    // Navigates back to the previous screen while preserving the current tab
    const handleOnBack = () => {
        navigate(backRoute, { state: { currentTab } });
    };
    // Validates if at least one identity document has a file.
    // If no files are present (all file values are null), the download button is disabled.
    const hasIdentityFiles = Object.values(identityDocuments || {}).some((item) => item?.file);

    const handleDownload = () => {
        const nameZip = formatName(getFullName(item?.name, item?.lastName));
        dispatch(ZipDownloadByUserId(userId)).then(({ payload: { data, code } }) => {
            if (data) {
                DownloadDataZip(data, nameZip)
            } else {
                errorMsg(code)
            }
        })
    }

    return (
        <>
            <HeadTittle name={'validation_identity'} onBack={handleOnBack}>
                { hasIdentityFiles &&
                    <ButtonAction
                        id='btn_idg_download'
                        name='download'
                        className='btn-icon-export'
                        Icon={DownloadIcon}
                        splitName={false}
                        onClick={handleDownload}
                    />
                }
            </HeadTittle>
            {identityDocuments && (
                <div className={'ml-15 mr-15'}>
                    <IdentityVerification
                        item={item}
                        disabled={true}
                        identityDocuments={identityDocuments}
                        identityValidationType={identityValidationType}
                        identityValidationStatus={identityValidationStatus}
                    />
                </div>
            )}
        </>
    );
};

export default IdentityDocumentsGrid;
